import CreateCommunityPage from "./createCommunity";

export default CreateCommunityPage;